export const Satoshi = {
    className: "font-satoshi",
    variable: "--font-satoshi",
    style: {
        fontFamily: "var(--font-satoshi)",
    },
};
